export default __webpack_public_path__ + "static/media/01.5d7cf8f0.jpg";